import React, {Component} from 'react';
import {Tab, TabPanel, Tabs, TabList} from 'react-tabs';
import {Editor} from '../editor-components';
import ScreenEmulator from '../screen-emulator/screen-emulator';
import GiftCardList from './gift-card-list';
import GiftCardBackground from './gift-card-background';
import GiftCardInstructions from './gift-card-instructions';

/** @class GiftCardEditor
  * A component for editing gift card packages
  * in a virutal expo.
  */
export default class GiftCardEditor extends Component {
  /** @constructor
    * Creates a new instance of a GiftCardEditor
    */
  constructor(props){
    super(props);
    const expoID = props.match.params.expoID;
    const showID = props.match.params.showID;
    const hallID = props.match.params.hallID;
    this.state = {
      expoID: expoID,
      showID: showID,
      hallID: hallID
    }
    this.dataURL = `expos/${expoID}/shows/${showID}`;
  }
  /** @function render
    * Renders the component.
    */
  render() {
    return (
      <Editor>
        <Tabs>
          <TabList>
            <Tab>Gift Cards</Tab>
            <Tab>Background</Tab>
            <Tab>Instructions</Tab>
            <Tab>Preview</Tab>
          </TabList>
          <TabPanel>
            <GiftCardList dataURL={this.dataURL} />
          </TabPanel>
          <TabPanel>
            <GiftCardBackground dataURL={this.dataURL} />
          </TabPanel>
          <TabPanel>
            <GiftCardInstructions dataURL={this.dataURL} />
          </TabPanel>
          <TabPanel>
            <ScreenEmulator src={`/preview/${this.state.expoID}/${this.state.showID}/#/giftCards`} />
          </TabPanel>
        </Tabs>
      </Editor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/gift-card-editor/gift-card-editor.js